/* This is a convenience gate for public resources, not authentication. */
(function (scope) {
  const ACCESS_KEY = 'woteExploreSignupCompleteV2';
  const PENDING_KEY = 'woteExplorePendingV3';
  const destinations = { grimoire: '/pages/the-grimoire', moon: '/pages/living-moon-portal' };
  const safeDestination = (value, origin) => {
    try {
      const url = new URL(value, origin);
      return url.origin === origin && Object.values(destinations).includes(url.pathname) ? url.pathname + url.search + url.hash : '';
    } catch (_) { return ''; }
  };
  const canGrantAccess = (posted, pending, now = Date.now()) => Boolean(posted && pending && Number.isFinite(pending.at) && now >= pending.at && now - pending.at < 60 * 60 * 1000);
  if (typeof module !== 'undefined' && module.exports) { module.exports = { safeDestination, canGrantAccess }; return; }
  const getStore = (name) => { try { return scope[name]; } catch (_) { return null; } };
  const localStore = getStore('localStorage');
  const sessionStore = getStore('sessionStorage');
  const read = (storage, key) => { try { return storage?.getItem(key); } catch (_) { return null; } };
  const write = (storage, key, value) => { try { if (!storage) return false; storage.setItem(key, value); return true; } catch (_) { return false; } };
  const access = () => read(localStore, ACCESS_KEY) === '1' || read(sessionStore, ACCESS_KEY) === '1';
  const current = new URL(scope.location.href);
  const destination = safeDestination(current.href, current.origin) || destinations[current.searchParams.get('interest')] || '';
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, current.origin);
    if (url.origin !== current.origin || url.pathname !== '/pages/explore') return;
    const target = destinations[url.searchParams.get('interest')];
    if (target && access()) link.href = target;
  });
  document.querySelectorAll('[data-explore-club]').forEach((club) => {
    const form = club.querySelector('form');
    const status = club.querySelector('[data-club-status]');
    const successful = Boolean(club.querySelector('[data-club-posted]'));
    let pending;
    try { pending = JSON.parse(read(sessionStore, PENDING_KEY) || 'null'); } catch (_) {}
    // With blocked session storage the Liquid success marker still permits this
    // response to be read; no claim of durable or authenticated access is made.
    const sessionWritable = write(sessionStore, 'woteExploreStorageCheck', '1');
    try { sessionStore?.removeItem('woteExploreStorageCheck'); } catch (_) {}
    if (canGrantAccess(successful, pending) || (successful && !sessionWritable)) {
      const persistent = write(localStore, ACCESS_KEY, '1');
      const session = write(sessionStore, ACCESS_KEY, '1');
      try { sessionStore?.removeItem(PENDING_KEY); } catch (_) {}
      document.documentElement.classList.add('explore-has-access');
      club.classList.add('is-new-member');
      if (status) {
        status.textContent = persistent ? 'Your subscription was accepted. Your access is now saved in this browser.' : session ? 'Your subscription was accepted. Access is saved for this browser session.' : 'Your subscription was accepted. This browser cannot save access; please allow local storage to keep it between visits.';
        status.focus({ preventScroll: true });
      }
      const target = safeDestination(pending?.destination, current.origin);
      if (target && target !== current.pathname + current.search + current.hash && (persistent || session)) {
        const resume = new URL(target, current.origin);
        if (current.searchParams.has('preview_theme_id')) resume.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
        scope.setTimeout(() => scope.location.replace(resume.href), scope.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 650);
      }
    } else if (access()) {
      document.documentElement.classList.add('explore-has-access');
      if (destination && current.pathname === '/pages/explore') scope.location.replace(destination);
    }
    form?.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      // Record only the attempt and destination, never an email or access grant.
      write(sessionStore, PENDING_KEY, JSON.stringify({ at: Date.now(), destination }));
      const button = form.querySelector('button[type="submit"]');
      if (button) button.textContent = 'Opening your invitation…';
    });
  });
})(typeof window !== 'undefined' ? window : globalThis);
